import React, { useState, useEffect } from "react";
import {
  X,
  BookOpen,
  Calendar,
  Clock,
  User,
  AlertCircle,
  CheckCircle,
  FileText,
  Target,
  Loader,
  Award,
  TrendingUp,
} from "lucide-react";
import axios from "axios";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import api from "../utils/api";
function StudentHomeworkModal({ visable, Close, userId }) {
  const [homeworks, setHomeworks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedTab, setSelectedTab] = useState("active");

  // Modal açıldığında ödevleri getir
  useEffect(() => {
    if (visable && userId) {
      fetchHomeworks();
    }
  }, [visable, userId]);

  // Ödevleri getir (notification'lardan)
  const fetchHomeworks = async () => {
    setLoading(true);
    setError("");

    try {
      // Öğrencinin bildirimlerinden ödev tipindeki bildirimleri al
      // const response = await axios.get(
      //   `${
      //     import.meta.env.VITE_REACT_APP_SERVER_URL
      //   }notification/user/${userId}`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
      //     },
      //   },
      // );

      const response = await api.get(`notification/user/${userId}`);
      if (response.data.success) {
        // Sadece ödev tipindeki bildirimleri filtrele
        const homeworkNotifications = response.data.notifications.filter(
          (notification) => notification.type === "homework",
        );

        // Bildirimleri ödev formatına çevir
        const homeworkData = homeworkNotifications.map((notification) => ({
          _id: notification._id,
          homeworkId: notification.data?.homeworkId,
          title: notification.data?.title || notification.title,
          subject: notification.data?.subject || "Genel",
          teacherName: notification.message.includes("tarafından")
            ? notification.message
                .split(" tarafından")[0]
                .replace("Yeni Ödev: ", "")
                .split(" - ")[1] || "Öğretmen"
            : "Öğretmen",
          dueDate: notification.data?.dueDate || notification.createdAt,
          priority: notification.data?.priority || "medium",
          description: notification.message,
          createdAt: notification.createdAt,
          read: notification.read,
          className: notification.data?.className || "Sınıf",
        }));

        setHomeworks(homeworkData);
      }
    } catch (error) {
      console.error("❌ Ödevler getirilemedi:", error);
      setError("Ödevler yüklenirken bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  // Tarih formatlama
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Kalan gün hesaplama
  const getDaysLeft = (dueDate) => {
    const now = new Date();
    const due = new Date(dueDate);
    const diffTime = due - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return { days: Math.abs(diffDays), status: "overdue" };
    if (diffDays === 0) return { days: 0, status: "today" };
    if (diffDays <= 3) return { days: diffDays, status: "urgent" };
    return { days: diffDays, status: "normal" };
  };

  // Öncelik rengini al
  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return "text-red-600 bg-red-100";
      case "medium":
        return "text-yellow-600 bg-yellow-100";
      case "low":
        return "text-green-600 bg-green-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  // Öncelik metnini al
  const getPriorityText = (priority) => {
    switch (priority) {
      case "high":
        return "Yüksek";
      case "medium":
        return "Orta";
      case "low":
        return "Düşük";
      default:
        return "Orta";
    }
  };

  // Ödevleri filtreleme
  const getFilteredHomeworks = () => {
    return homeworks.filter((homework) => {
      const daysLeft = getDaysLeft(homework.dueDate);

      switch (selectedTab) {
        case "active":
          return daysLeft.status !== "overdue";
        case "overdue":
          return daysLeft.status === "overdue";
        case "completed":
          return homework.read; // Okunmuş olanları tamamlanmış say
        default:
          return true;
      }
    });
  };

  const filteredHomeworks = getFilteredHomeworks();

  // Tab sayılarını hesapla
  const tabCounts = {
    active: homeworks.filter((h) => getDaysLeft(h.dueDate).status !== "overdue")
      .length,
    overdue: homeworks.filter(
      (h) => getDaysLeft(h.dueDate).status === "overdue",
    ).length,
    completed: homeworks.filter((h) => h.read).length,
  };

  //araka plan fonksiyon
  const handleBackground = () => {
    return <BackGroundColor />;
  };
  if (!visable) return null;

  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-25 p-4">
      <BackGroundColor />
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden z-50">
        {/* Header */}
        <div className="bg-yellow-500 text-white p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <BookOpen className="w-8 h-8" />
              <div>
                <h2 className="text-xl font-bold">Ödevlerim</h2>
                <hr className="border-2 border-purple-500 " />
                <p className="text-purple-100 mt-1">
                  Toplam {homeworks.length} ödev
                </p>
              </div>
            </div>
            <button
              onClick={Close}
              className="p-2 hover:bg-purple-500 hover:bg-opacity-20 rounded-full transition-colors"
            >
              <X className="w-6 h-6 " />
            </button>
          </div>
        </div>
        {/* Mobil ödev kısmı - 1200px altı için görünür */}
        <div className="block [@media(min-width:1200px)]:hidden px-2 mb-4">
          <div
            className="bg-white backdrop-blur-md rounded-2xl p-2 
          shadow-inner"
          >
            {/* Grid yapısı: Mobilde 3 sütun (yan yana), tabletlerde geniş alan */}
            <div className="grid grid-cols-3 gap-2">
              {/* Aktif Ödevler */}
              <div
                className="flex flex-col items-center justify-center bg-gray-100 p-2 
              rounded-xl shadow-sm  hover:scale-105 transition-transform"
              >
                <div className="p-2 bg-purple-500 rounded-lg mb-1">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-bold text-gray-500 leading-none">
                  {tabCounts.active}
                </span>
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider mt-1">
                  Aktif
                </span>
              </div>

              {/* Geciken Ödevler */}
              <div
                className="flex flex-col items-center justify-center bg-gray-100 p-2 rounded-xl 
              shadow-sm  hover:scale-105 transition-transform"
              >
                <div className="p-2 bg-purple-500 rounded-lg mb-1">
                  <AlertCircle className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-bold text-gray-500 leading-none">
                  {tabCounts.overdue}
                </span>
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider mt-1">
                  Geciken
                </span>
              </div>

              {/* Tamamlanan Ödevler */}
              <div
                className="flex flex-col items-center justify-center bg-gray-100 p-2 rounded-xl shadow-sm border
               border-green-100 hover:scale-105 transition-transform"
              >
                <div className="p-2 bg-purple-500 rounded-lg mb-1">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-bold text-gray-500 leading-none">
                  {tabCounts.completed}
                </span>
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider mt-1">
                  Biten
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Stats Cards */}
        <div className="hidden [@media(min-width:1200px)]:block p-6 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gray-100 rounded-lg p-4 shadow-sm">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-purple-500 rounded-lg">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-500">
                    {tabCounts.active}
                  </div>
                  <div className="text-gray-600 text-sm">Aktif Ödev</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 rounded-lg p-4 shadow-sm">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-purple-500 rounded-lg">
                  <AlertCircle className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-500">
                    {tabCounts.overdue}
                  </div>
                  <div className="text-gray-600 text-sm">Geciken Ödev</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 rounded-lg p-4 shadow-sm">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-purple-500 rounded-lg">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-500">
                    {tabCounts.completed}
                  </div>
                  <div className="text-gray-600 text-sm">Tamamlanan</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="px-6 border-b border-gray-200">
          <div className="flex space-x-8">
            <button
              onClick={() => setSelectedTab("active")}
              className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                selectedTab === "active"
                  ? "border-purple-500 text-purple-500"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              Aktif Ödevler ({tabCounts.active})
            </button>
            <button
              onClick={() => setSelectedTab("overdue")}
              className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                selectedTab === "overdue"
                  ? "border-purple-500 text-purple-500"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              Geciken ({tabCounts.overdue})
            </button>
            <button
              onClick={() => setSelectedTab("completed")}
              className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                selectedTab === "completed"
                  ? "border-purple-500 text-purple-500"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              Tamamlanan ({tabCounts.completed})
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-96">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Loader className="w-8 h-8 animate-spin text-blue-600" />
              <span className="ml-3 text-gray-600">Ödevler yükleniyor...</span>
            </div>
          ) : error ? (
            <div className="text-center py-12">
              <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
              <p className="text-red-600 mb-4">{error}</p>
              <button
                onClick={fetchHomeworks}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Tekrar Dene
              </button>
            </div>
          ) : filteredHomeworks.length === 0 ? (
            <div className="text-center py-12">
              <BookOpen className="w-12 h-12 text-purple-500 mx-auto mb-4" />
              <p className="text-gray-600">
                {selectedTab === "active" && "Aktif ödev bulunmuyor"}
                {selectedTab === "overdue" && "Geciken ödev bulunmuyor"}
                {selectedTab === "completed" && "Tamamlanan ödev bulunmuyor"}
              </p>
            </div>
          ) : (
            <div className="space-y-4">
              {filteredHomeworks.map((homework) => {
                const daysLeft = getDaysLeft(homework.dueDate);

                return (
                  <div
                    key={homework._id}
                    className={`bg-gray-100 border rounded-xl p-6
                       transition-all duration-200 hover:shadow-md ${
                         !homework.read
                           ? "bg-blue-50 border-gray-100"
                           : "bg-white border-gray-100"
                       }`}
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <div className="flex flex-col">
                            <h3 className="text-lg font-semibold text-gray-900">
                              {homework.title}
                            </h3>
                            <hr className="border-2 border-purple-500 " />
                          </div>
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(
                              homework.priority,
                            )}`}
                          >
                            {getPriorityText(homework.priority)}
                          </span>
                        </div>

                        <div className="flex items-center space-x-6 text-sm text-gray-600 mb-3">
                          <div className="flex items-center space-x-1">
                            <BookOpen className="w-4 h-4 text-purple-500" />
                            <span>{homework.subject}</span>
                          </div>
                          <div className="flex items-center space-x-1">
                            <User className="w-4 h-4 text-purple-500" />
                            <span>{homework.teacherName}</span>
                          </div>
                          <div className="flex items-center space-x-1">
                            <Calendar className="w-4 h-4 text-purple-500" />
                            <span>{formatDate(homework.dueDate)}</span>
                          </div>
                        </div>

                        <p className="text-gray-700 mb-3 text-sm leading-relaxed">
                          {homework.description}
                        </p>

                        <div className="flex items-center justify-between">
                          <div className="text-xs text-gray-500">
                            Sınıf: {homework.className}
                          </div>

                          <div className="flex items-center space-x-2">
                            {daysLeft.status === "overdue" && (
                              <div
                                className="flex items-center space-x-1
                               text-red-600 text-sm font-medium"
                              >
                                <AlertCircle className="w-4 h-4 " />
                                <span>{daysLeft.days} gün gecikti</span>
                              </div>
                            )}
                            {daysLeft.status === "today" && (
                              <div
                                className="flex items-center space-x-1
                               text-orange-600 text-sm font-medium"
                              >
                                <Clock className="w-4 h-4" />
                                <span>Bugün teslim</span>
                              </div>
                            )}
                            {daysLeft.status === "urgent" && (
                              <div
                                className="flex items-center space-x-1
                               text-yellow-600 text-sm font-medium"
                              >
                                <Clock className="w-4 h-4" />
                                <span>{daysLeft.days} gün kaldı</span>
                              </div>
                            )}
                            {daysLeft.status === "normal" && (
                              <div
                                className="flex items-center space-x-1
                               text-gray-600 text-sm"
                              >
                                <Clock className="w-4 h-4 text-purple-500" />
                                <span>{daysLeft.days} gün kaldı</span>
                              </div>
                            )}

                            {homework.read && (
                              <div className="flex items-center space-x-1 text-green-600 text-sm">
                                <CheckCircle className="w-4 h-4" />
                                <span>Görüldü</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-yellow-500 border-t border-gray-200">
          <div className="flex items-center justify-between text-sm text-white">
            <span>
              Son güncelleme: {new Date().toLocaleTimeString("tr-TR")}
            </span>
            <button
              onClick={fetchHomeworks}
              disabled={loading}
              className="flex items-center space-x-2 px-3 py-1 text-blue-600 hover:text-blue-700 font-medium"
            >
              <TrendingUp className="w-4 h-4 text-white" />
              <span className="text-white">Yenile</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentHomeworkModal;
